import { apiRequest } from "../../api/apiRequest";
import { GET_SCHOOL_LIST } from "../../utils/api";
import { SCHOOL_LIST_FAILURE, SCHOOL_LIST_SUCCESS } from "./masterData.actionTypes";


export const getSchoolList = () => async (dispatch) => {
  const result = await apiRequest("get", `${GET_SCHOOL_LIST}`);

  if (result.success) {
    dispatch({
      type: SCHOOL_LIST_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: SCHOOL_LIST_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};